<script setup lang="ts">
import NuxtLinkButton from './NuxtLinkButton.vue'

const props = defineProps<{
  limit?: number
  paginate?: boolean
}>()
const { org, urlBase } = useContext()
const page = ref(1)

const { data: news } = await useApi('/competition/{season}/news', {
  query: {
    per_page: props.limit ?? 3,
    page,
  },
  path: {
    season: org.current_season.slug,
  },
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <NuxtLink
      v-for="item in news?.data"
      :key="item.id"
      :to="urlBase + 'news/' + item.slug"
    >
      <Panel :header="item.title">
        <p class="opacity-75">
          {{ item.created_at }}
        </p>
        <p class="max-w-2xl">
          {{ item.summary }}
        </p>
        <template #footer>
          <div class="flex flex-row justify-end">
            <Button
              size="small"
            >
              {{ $t('Read more') }}
            </Button>
          </div>
        </template>
      </Panel>
    </NuxtLink>
    <div
      v-if="!props.paginate"
      class="flex justify-end pt-4 w-full"
    >
      <NuxtLinkButton
        :to="$getPathFor('news', urlBase)"
      >
        {{ $t('View all news') }}
      </NuxtLinkButton>
    </div>
    <SitePagination
      v-if="news && props.paginate"
      v-model="page"
      :meta="news?.meta"
    />
  </div>
</template>
